import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from "../../../service/auth.service";

@Component({
  selector: 'app-login-page',
  templateUrl: './login.component.html',
  imports: [
    ReactiveFormsModule,
    ButtonModule,
  ]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  redirectUrl?: string;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
      password: ['', Validators.required]
    });
    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params['redirect'] || '/dashboard';
    });
  }

  async ngOnInit(): Promise<void> {

  }

  onLogin() {
    if (this.loginForm.valid) {
      // Your backend login logic here
      console.log('Logging in with:', this.loginForm.value);
    }
  }

  loginWithOAuth() {
    this.isLoading = true;
    this.authService.login()
      .then((res) => {
        console.log(res);
        this.isLoading = false;
      })
      .catch(err => {
        console.log(err);
        this.isLoading = false;
      });
  }
}
